import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { useStore } from '../../useStore';
import { useInventorizeStepsStore } from '../../components/store';
import { ReadingStepFooter as messages } from './messages';

export const ReadingStepFooter: React.FC = () => {
  const { commodity, newMeter } = useStore();
  const { setPreviousStep } = useInventorizeStepsStore();

  return (
    <>
      <Button block style={{ marginRight: 15 }} type="default" onClick={() => setPreviousStep({ commodity, newMeter })}>
        <FormattedMessage {...messages.back} />
      </Button>

      <Button key="submit" block form="readingStepForm" htmlType="submit" type="primary">
        <FormattedMessage {...messages.next} />
      </Button>
    </>
  );
};
